import styled from 'styled-components';

import { CommonCard } from '../HealthSummary.style';

export const CardWrapper = styled(CommonCard)`
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`;
